import { z } from 'my-zod'
import { operatorsModel } from '../../outfitter-account-management/outfitter'
import { vehiclesModel } from '../vehicle'
import { serviceBulletinsModel, serviceBulletinVehicleAssociation } from './service-bulletins-model'

export const serviceBulletinVehicleAssociationSystemView = serviceBulletinVehicleAssociation.augment({
  vehicleVin: vehiclesModel.shape.vin,
  contractedPickupDate: vehiclesModel.shape.contractedPickupDate,
  lifecycleStatus: vehiclesModel.shape.lifecycleStatus,
  outfitterId: vehiclesModel.shape.operatorId,
  outfitterName: operatorsModel.shape.businessName.nullish(),
  programType: vehiclesModel.shape.programType
})
export type serviceBulletinVehicleAssociationSystemView = z.infer<typeof serviceBulletinVehicleAssociationSystemView>

export const serviceBulletinSystemView = serviceBulletinsModel.omit({ vehicleAssociations: true }).augment({
  vehicleAssociations: serviceBulletinVehicleAssociationSystemView.array()
})

export type serviceBulletinSystemView = z.infer<typeof serviceBulletinSystemView>
